import { render, staticRenderFns } from "./k2Modal.vue?vue&type=template&id=4c1cc9c1"
import script from "./k2Modal.vue?vue&type=script&lang=js"
export * from "./k2Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports